/* Sunny Stripes - bulk materials delivery + installation quote.
   RATE CARD lives at the top of this file. Edit here to reprice the whole tool.

   WHY THESE PRICES ARE NOT IN assets/ss-rates.js
   Every other quote builder reads the shared rate card, because the services
   they sell are sold on more than one page and used to disagree with each
   other. Bulk materials are sold here and nowhere else, so this is their one
   home. ss-rates.js carries a pointer saying so. Do not copy this list there -
   two copies of a price is the exact failure the shared card exists to stop.

   PRICING BASIS (Aug 2026, market-derived - NOT yet confirmed against supplier cost):
     Mulch material        national range $25-100/yd, installed $50-150/yd
     Mulch spread labor   $20-50/yd
     Screened topsoil      $30-40/yd at small volumes
     Screened compost      $20-50/yd national (HomeGuide 2026); ours is above
                           that band on purpose - same screened blend we spread
                           in the topdressing service, not the cheapest pile
     River rock            $45-130/ton, 1 ton covers 115-135 sq ft at 2 inches
     Delivery              $50-150 per trip
     Old mulch removal     $20-50/yd
   Coverage figures match the ones already published on the bulk delivery page:
     mulch 1 yd = 100 sq ft at 3in, soil 1 yd = 160 sq ft at 2in, stone 1 ton = 125 sq ft at 2in

   HOW DEPTH WORKS (added 2026-09-12)
   Each material carries a REFERENCE coverage at a REFERENCE depth - the figures
   above, which are the ones printed on the page, in the FAQ and in the schema.
   Coverage at any other depth is scaled inversely from that pair:

     coverAt(m, d) = m.cover * (m.refDepth / d)

   Geometry says one cubic yard covers 324 sq ft an inch deep, which would make
   mulch 108 sq ft at 3in rather than 100. The gap is real - mulch settles, and
   nobody spreads to the millimetre - so the published anchors are kept and
   scaled rather than replaced with the textbook number. That way the tool and
   the sentences around it can never disagree: at the reference depth this
   returns exactly the figure the page prints, and halving the depth doubles
   the coverage, which is the part customers actually needed.

   Before this existed the tool assumed one depth per material and quoted a
   quarter-inch compost dusting and a six-inch raised-bed fill as if they were
   the same job.
*/
(function(){
  "use strict";

  var RATES = {
    /* per-unit material price, delivered price is material + delivery fee below */
    materials: [
      {k:"mulch-hardwood", grp:"Mulch", nm:"Hardwood mulch",        unit:"yd",  price:48,  cover:100, refDepth:3,
       desc:"Natural double-ground. The workhorse - breaks down into the soil and feeds the beds."},
      {k:"mulch-dyed",     grp:"Mulch", nm:"Dyed mulch",            unit:"yd",  price:58,  cover:100, refDepth:3,
       desc:"Black, brown or red. Holds its color through the season - tell us the color when we call."},
      {k:"mulch-cedar",    grp:"Mulch", nm:"Cedar mulch",           unit:"yd",  price:68,  cover:100, refDepth:3,
       desc:"Aromatic and slow to break down. Costs more, lasts longer."},
      {k:"topsoil",        grp:"Soil",  nm:"Screened topsoil",      unit:"yd",  price:38,  cover:160, refDepth:2,
       desc:"For raised beds, lawn repair and filling low spots. Screened, so you spread soil instead of sorting rocks."},
      /* Compost is the same screened blend we spread in the topdressing service.
         Coverage here is the BED figure - 2 inches worked into a garden. Spread
         on a lawn it goes down about a quarter inch, where one yard covers more
         like 1,300 sq ft, so the description sends whole-lawn jobs to the
         topdressing page rather than letting somebody order eight yards to rake
         across their grass. */
      {k:"compost",        grp:"Soil",  nm:"Screened compost",      unit:"yd",  price:60,  cover:160, refDepth:2,
       desc:"Rich organic matter for garden beds, borders and vegetable plots. Topdressing a whole lawn is a different job - we spread it far thinner and price it by the lawn on the topdressing page."},
      {k:"stone-pea",      grp:"Stone", nm:"Pea stone / washed gravel", unit:"ton", price:75,  cover:125, refDepth:2,
       desc:"Paths, drainage, dog runs. The cheapest way to cover ground that stays covered."},
      {k:"stone-river",    grp:"Stone", nm:"River rock, 1-2 inch",  unit:"ton", price:95,  cover:125, refDepth:2,
       desc:"Beds, borders and dry creek beds. Rounded, so it stays put and is easy underfoot."},
      {k:"stone-granite",  grp:"Stone", nm:"Decorative granite",    unit:"ton", price:125, cover:125, refDepth:2,
       desc:"Premium look that holds its color. Heavier and slower to place, priced accordingly."}
    ],
    delivery: 75,            /* flat, anywhere in Sheboygan County */
    bigLoadThreshold: 10,    /* over this many units it is a second trip */
    bigLoadExtra: 75,
    minUnits: 2,             /* below this, bagged is genuinely cheaper - we say so */
    installMulchPerYd: 45,   /* spreading labor */
    installSoilPerYd: 45,
    installStonePerTon: 75,  /* heavier and slower than mulch */
    bedPrepPerSqft: 0.35,    /* weeding + fresh edge cut */
    removalPerYd: 40,        /* hauling out the old mulch first */

    /* The depths a customer can pick, and what each one is for. These are
       ADVICE, not prices - nothing here changes a rate, only how many yards
       the same area needs. The `use` line is what makes the picker worth
       having: most people do not know how deep mulch goes, and a tool that
       silently assumed three inches was answering a question they had not
       asked. Order matters; the row renders in this order. */
    depths: [
      { in:0.25, use:"A light compost dusting on a lawn." },
      { in:0.5,  use:"A heavier dusting, or filling in behind a seeding." },
      { in:1,    use:"Topping up a bed that still has last year's mulch under it." },
      { in:2,    use:"Garden beds, vegetable plots, and stone over landscape fabric." },
      { in:3,    use:"Mulch beds. Thick enough to hold moisture and shade out weeds, thin enough not to smother roots." },
      { in:4,    use:"A new planting bed, or a weedy bed you want to bury properly." },
      { in:6,    use:"Filling a low spot, or building a raised bed up from the ground." },
      { in:8,    use:"A deep fill — a raised bed built from scratch." },
      { in:12,   use:"Full-depth fill. Worth measuring twice; that is a lot of material." }
    ]
  };

  var KLAVIYO = { publicApiKey:"SKBLA9" };

  /* Delivery runs county-wide, which is wider than the route-based services.
     This list matches the towns promised on the bulk delivery page. */
  var GOOGLE = {
    apiKey: "AIzaSyB8JkZAqLw39qEuj3FKGUsVQ9Yzp5mIAck",
    center: { lat:43.75, lng:-87.75 },
    bounds: { west:-88.20, south:43.53, east:-87.58, north:43.90 },
    region: "us", state: "WI", county: "sheboygan"
  };

  var S = {
    step:1, mode:"area", material:"mulch-hardwood",
    units:null, sqft:null, install:false,
    bedPrep:false, removal:false, outOfArea:false,
    /* Starts at hardwood mulch's reference depth. Until the customer touches
       the depth row, switching material re-snaps this to that material's own
       reference - pick topsoil and you get 2 inches, not the 3 you never chose.
       Once they HAVE picked a depth it is theirs and we stop moving it, because
       silently resetting somebody's input is worse than an odd default. */
    depth:3, depthTouched:false
  };

  var $  = function(id){ return document.getElementById(id); };
  var money = function(n){ return "$" + Math.round(n).toLocaleString("en-US"); };
  var esc = function(s){ return String(s == null ? "" : s).replace(/[&<>"]/g, function(c){
    return {"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;"}[c]; }); };
  function hideErr(id){ var e = $(id); if (e) e.style.display = "none"; }
  function mat(){ for (var i=0;i<RATES.materials.length;i++){ if (RATES.materials[i].k === S.material) return RATES.materials[i]; } return RATES.materials[0]; }
  function unitLabel(m, n){ return m.unit === "ton" ? (n === 1 ? "ton" : "tons") : (n === 1 ? "yard" : "yards"); }

  /* ---------------- depth ---------------- */
  /* Fractions get the real glyph rather than 0.25" - it reads as a measurement
     instead of a number, which is what a tape measure would say. */
  function depthLabel(d){
    if (d === 0.25) return "¼″";
    if (d === 0.5)  return "½″";
    return d + "″";
  }
  function depthOpt(d){
    for (var i=0;i<RATES.depths.length;i++){ if (RATES.depths[i]["in"] === d) return RATES.depths[i]; }
    return RATES.depths[4];
  }
  /* The depth we are actually pricing at. In "I know the quantity" mode the
     customer has told us the yards outright, so the depth row is hidden and
     anything we SAY about coverage is said at the material's reference depth
     rather than at whatever chip happened to be lit. */
  function activeDepth(){ return S.mode === "area" ? S.depth : mat().refDepth; }

  /* Coverage scales inversely with depth from each material's published anchor
     - see HOW DEPTH WORKS at the top of this file. */
  function coverAt(m, d){ return m.cover * (m.refDepth / d); }

  /* Coverage is an estimate, so it is shown as one - to the nearest 5 sq ft.
     NOT to the nearest 10: every published anchor ends in 0 or 5, and rounding
     to 10 turned the stone figure into "about 130 sq ft" on a page that says
     125 three times. A display rounding that can move a published number is a
     rounding rule that will eventually be quoted back at us. */
  function roundCover(v){ return Math.round(v/5)*5; }

  /* ---------------- the maths ---------------- */
  function unitsNeeded(){
    var m = mat();
    if (S.mode === "units") return S.units || null;
    if (!S.sqft) return null;
    return Math.ceil((S.sqft / coverAt(m, S.depth)) * 2) / 2;   /* round up to the nearest half unit */
  }

  /* What the same job costs in 1 cu ft bags from a garden center. From the AREA
     and depth where we have them, because that is the literal volume of the
     space being filled; from the yards otherwise, at 27 cu ft to the yard.
     Stone quoted in tons has no volume we can state without a density figure we
     do not have, so it returns null and the line simply doesn't render. */
  function bagsNeeded(u){
    if (S.mode === "area" && S.sqft) return Math.ceil(S.sqft * (S.depth / 12));
    if (mat().unit === "yd" && u) return Math.ceil(u * 27);
    return null;
  }

  function quote(){
    var m = mat(), u = unitsNeeded();
    if (!u) return { empty:true };
    var material = u * m.price;
    var delivery = RATES.delivery + (u > RATES.bigLoadThreshold ? RATES.bigLoadExtra : 0);
    var install = 0, prep = 0, removal = 0;
    if (S.install){
      var rate = m.unit === "ton" ? RATES.installStonePerTon
               : (m.grp === "Soil" ? RATES.installSoilPerYd : RATES.installMulchPerYd);
      install = u * rate;
      if (S.mode === "area" && S.bedPrep && S.sqft) prep = S.sqft * RATES.bedPrepPerSqft;
      if (S.removal) removal = u * RATES.removalPerYd;
    }
    var total = material + delivery + install + prep + removal;
    return {
      empty:false, m:m, units:u, material:material, delivery:delivery,
      install:install, prep:prep, removal:removal, total:total,
      depth: activeDepth(), bags: bagsNeeded(u),
      belowMin: u < RATES.minUnits,
      twoTrips: u > RATES.bigLoadThreshold
    };
  }

  /* ---------------- rendering ---------------- */
  function buildMaterials(){
    var groups = {}, order = [];
    RATES.materials.forEach(function(m){
      if (!groups[m.grp]){ groups[m.grp] = []; order.push(m.grp); }
      groups[m.grp].push(m);
    });
    var html = "";
    order.forEach(function(g){
      html += '<div class="matgrp"><div class="matgrp-h">' + esc(g) + '</div><div class="lots">';
      groups[g].forEach(function(m){
        var on = (S.material === m.k);
        html += '<div class="lot' + (on ? " sel" : "") + '" data-mat="' + m.k + '">' +
                '<span class="tick">✓</span>' +
                '<div class="nm">' + esc(m.nm) + '</div>' +
                '<div class="sz">' + money(m.price) + ' per ' + (m.unit === "ton" ? "ton" : "yard") + '</div>' +
                '<div class="hint">' + esc(m.desc) + '</div>' +
                '</div>';
      });
      html += '</div></div>';
    });
    $("mqmats").innerHTML = html;
  }

  function buildDepths(){
    var html = "";
    RATES.depths.forEach(function(d){
      var on = (S.depth === d["in"]);
      html += '<button type="button" class="dchip' + (on ? " on" : "") + '" data-depth="' + d["in"] + '"' +
              ' aria-pressed="' + (on ? "true" : "false") + '">' + depthLabel(d["in"]) + '</button>';
    });
    $("mqdepths").innerHTML = html;
  }

  function render(){
    var m = mat(), q = quote(), d = activeDepth();

    $("mqdepthUse").innerHTML = "<b>" + depthLabel(S.depth) + "</b> — " + esc(depthOpt(S.depth).use);

    $("mqcoverNote").innerHTML = "At " + depthLabel(d) + " deep, one " + (m.unit === "ton" ? "ton" : "yard") +
      " of " + esc(m.nm.toLowerCase()) + " covers about <b>" +
      roundCover(coverAt(m, d)).toLocaleString("en-US") + " sq ft</b>.";

    /* The bagged comparison. Two yards delivered is one stop; the same job in
       bags is fifty-four of them and three trips in the car. We are not selling
       against bags below the minimum - the flag in the rail already says bagged
       is cheaper there, and both things can be true. */
    var bag = $("mqbagLine");
    if (!q.empty && q.bags){
      bag.style.display = "block";
      bag.innerHTML = "Bought bagged, that is about <b>" + q.bags.toLocaleString("en-US") +
        " one-cubic-foot bags</b>.";
    } else {
      bag.style.display = "none";
    }

    /* Compost spread that thin over an area that big is not a bulk order, it is
       the topdressing SERVICE - done with the EcoLawn, priced by the lawn. The
       tool could happily quote it as eight yards on a driveway; sending them to
       the right page is the honest answer even though it is the smaller sale. */
    var steer = $("mqsteer");
    var isThinCompost = (m.grp === "Soil" && S.mode === "area" && S.depth <= 0.5 && S.sqft && S.sqft >= 1500);
    if (isThinCompost){
      steer.style.display = "block";
      steer.innerHTML = "Spreading " + esc(m.nm.toLowerCase()) + " that thin across an area this size is " +
        "lawn topdressing — a different job, done with a topdresser and priced by the lawn. " +
        '<a href="/pages/topdressing">Price it on the topdressing page →</a>';
    } else {
      steer.style.display = "none";
    }

    $("mqunitword").textContent = m.unit === "ton" ? "tons" : "yards";
    $("mqinstallLbl").textContent = m.unit === "ton"
      ? "Have us spread it — " + money(RATES.installStonePerTon) + " per ton"
      : "Have us spread it — " + money(m.grp === "Soil" ? RATES.installSoilPerYd : RATES.installMulchPerYd) + " per yard";
    $("mqextras").style.display = S.install ? "block" : "none";
    $("mqsvcInstall").classList.toggle("on", S.install);
    $("mqsvcPrep").classList.toggle("on", S.bedPrep);
    $("mqsvcRemoval").classList.toggle("on", S.removal);
    /* bed prep is priced per sq ft, so it only makes sense when we know the area */
    $("mqsvcPrep").style.display = (S.mode === "area") ? "" : "none";

    if (q.empty){
      $("mqEstHead").textContent = "$0";
      $("mqEstArea").textContent = S.mode === "area"
        ? "Enter your bed size to price it"
        : "Enter how many " + (m.unit === "ton" ? "tons" : "yards") + " you need";
      $("mqEstItems").innerHTML = "";
      $("mqEstTotals").style.display = "none";
      $("mqFlagMin").classList.remove("show");
      $("mqFlagBig").classList.remove("show");
      $("mqmAmt").innerHTML = "$0<small>your estimate</small>";
      return;
    }

    $("mqEstHead").textContent = money(q.total);
    $("mqEstArea").textContent = q.units + " " + unitLabel(m, q.units) + " of " + m.nm.toLowerCase() +
      (S.mode === "area" && S.sqft
        ? " · " + Math.round(S.sqft).toLocaleString("en-US") + " sq ft at " + depthLabel(S.depth)
        : "");
    $("mqmAmt").innerHTML = money(q.total) + "<small>delivered" + (S.install ? " + spread" : "") + "</small>";

    var items = '<div class="item"><span class="nm">' + esc(m.nm) +
      '<small>' + q.units + ' ' + unitLabel(m, q.units) + ' at ' + money(m.price) + ' each</small></span>' +
      '<span class="amt">' + money(q.material) + '</span></div>';
    items += '<div class="item"><span class="nm">Delivery<small>' +
      (q.twoTrips ? "Two trips — this is more than one load" : "Anywhere in Sheboygan County") +
      '</small></span><span class="amt">' + money(q.delivery) + '</span></div>';
    if (q.install)  items += '<div class="item"><span class="nm">Spreading<small>our crew places it</small></span><span class="amt">' + money(q.install) + '</span></div>';
    if (q.prep)     items += '<div class="item"><span class="nm">Bed prep<small>weeding and a fresh edge</small></span><span class="amt">' + money(q.prep) + '</span></div>';
    if (q.removal)  items += '<div class="item"><span class="nm">Old mulch removed<small>hauled away</small></span><span class="amt">' + money(q.removal) + '</span></div>';
    $("mqEstItems").innerHTML = items;

    $("mqEstTotals").style.display = "block";
    $("mqTGrand").textContent = money(q.total);

    $("mqFlagMin").classList.toggle("show", q.belowMin);
    $("mqFlagBig").classList.toggle("show", q.twoTrips);
  }

  /* ---------------- steps ---------------- */
  function show(n){
    if (n === 2 && !validate(1)) return;
    S.step = n;
    ["mp1","mp2"].forEach(function(id,i){ $(id).style.display = (i+1===n) ? "block" : "none"; });
    $("mpDone").style.display = "none";
    var sts = $("mqsteps").children;
    for (var i=0;i<sts.length;i++){
      sts[i].classList.toggle("active", i+1===n);
      sts[i].classList.toggle("done", i+1<n);
    }
    $("mqfill").style.width = (n/2*100) + "%";
    $("mqmBtn").textContent = n===1 ? "Where's it going? →" : "Send my order →";
    var t = $("mqtool");
    if (t) window.scrollTo({ top: t.offsetTop - 20, behavior:"smooth" });
  }

  function validate(n){
    if (n === 1){
      var q = quote(), e = $("mqe1");
      if (q.empty){
        e.style.display = "block";
        e.textContent = S.mode === "area"
          ? "Tell us roughly how big the area is so we can work out the quantity."
          : "Enter how many " + (mat().unit === "ton" ? "tons" : "yards") + " you need.";
        return false;
      }
      e.style.display = "none";
      return true;
    }
    if (n === 2){
      var bad = [], need = ["mqfname","mqemail","mqphone","mqaddr"];
      need.forEach(function(id){
        var el = $(id), empty = !el.value.trim();
        el.classList.toggle("bad", empty);
        if (empty) bad.push(el);
      });
      var em = $("mqemail");
      if (em.value.trim() && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em.value.trim())){ em.classList.add("bad"); bad.push(em); }
      var e2 = $("mqe2");
      /* Out of the county is a hard stop - we can't get a truck there. */
      if (S.outOfArea){
        $("mqaddr").classList.add("bad");
        e2.style.display = "block";
        e2.textContent = "That address is outside Sheboygan County — we can't get a truck out there. " +
                         "Call us at (920) 943-6422 if you think that's wrong.";
        return false;
      }
      e2.style.display = bad.length ? "block" : "none";
      e2.textContent = "We need a delivery address, a name, an email and a phone number.";
      if (bad.length) bad[0].focus();
      return !bad.length;
    }
    return true;
  }

  /* ---------------- address autocomplete ---------------- */
  var AC = { ready:false, lib:null, token:null, sug:[], active:-1, timer:null };
  var PIN = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>';

  function loadMaps(){
    if (window.google && window.google.maps && window.google.maps.importLibrary) return initAC();
    if (document.getElementById("mq-gmaps")) return;
    window.__mqGmaps = initAC;
    var sc = document.createElement("script");
    sc.id = "mq-gmaps"; sc.async = true;
    sc.src = "https://maps.googleapis.com/maps/api/js?key=" + encodeURIComponent(GOOGLE.apiKey) +
             "&libraries=places&v=weekly&callback=__mqGmaps";
    sc.onerror = function(){ AC.ready = false; };
    document.head.appendChild(sc);
  }
  function initAC(){
    try{
      google.maps.importLibrary("places").then(function(lib){
        AC.lib = lib; AC.ready = !!(lib && lib.AutocompleteSuggestion);
      })["catch"](function(){ AC.ready = false; });
    }catch(e){ AC.ready = false; }
  }
  function acClose(){
    var b = $("mqaddrSuggest");
    b.classList.remove("open"); b.innerHTML = "";
    AC.sug = []; AC.active = -1;
  }
  function acFetch(q){
    if (!AC.ready || q.length < 3) return acClose();
    try{
      if (!AC.token && AC.lib.AutocompleteSessionToken) AC.token = new AC.lib.AutocompleteSessionToken();
      AC.lib.AutocompleteSuggestion.fetchAutocompleteSuggestions({
        input: q, sessionToken: AC.token || undefined,
        includedRegionCodes: [GOOGLE.region],
        /* bounds, not a circle - the new Places API rejects {center,radius} here */
        locationRestriction: GOOGLE.bounds
      }).then(function(res){ AC.sug = (res && res.suggestions) || []; acRender(); })
        ["catch"](function(){ acClose(); });
    }catch(e){ acClose(); }
  }
  function acRender(){
    var box = $("mqaddrSuggest"), html = "", n = 0;
    AC.sug.forEach(function(s,i){
      var p = s.placePrediction; if (!p) return;
      var main = (p.mainText && p.mainText.text) || (p.text && p.text.text) || "";
      var sub  = (p.secondaryText && p.secondaryText.text) || "";
      html += '<div class="as-item" data-i="'+i+'" role="option">' + PIN +
              '<span><span class="as-main">'+esc(main)+'</span> <span class="as-sub">'+esc(sub)+'</span></span></div>';
      n++;
    });
    if (!n) return acClose();
    html += '<div class="as-foot">Powered by Google</div>';
    box.innerHTML = html; box.classList.add("open"); AC.active = -1;
  }
  function acChoose(i){
    var s = AC.sug[i]; if (!s || !s.placePrediction) return;
    var p = s.placePrediction;
    try{
      var place = p.toPlace();
      place.fetchFields({ fields:["addressComponents","formattedAddress"] }).then(function(){ acFill(place); })
        ["catch"](function(){ $("mqaddr").value = (p.text && p.text.text) || $("mqaddr").value; });
    }catch(e){ $("mqaddr").value = (p.text && p.text.text) || $("mqaddr").value; }
    AC.token = null; acClose();
  }
  function acFill(place){
    var c = place.addressComponents || [];
    function get(t, short){
      for (var i=0;i<c.length;i++){
        var types = c[i].types || [];
        if (types.indexOf(t) >= 0) return (short ? c[i].shortText : c[i].longText) || c[i].longText || "";
      }
      return "";
    }
    var street = ((get("street_number") ? get("street_number") + " " : "") + get("route")).trim();
    $("mqaddr").value = street || place.formattedAddress || $("mqaddr").value;
    $("mqaddr").classList.remove("bad");
    var city = get("locality") || get("sublocality") || get("administrative_area_level_3");
    var state = get("administrative_area_level_1", true);
    var county = get("administrative_area_level_2");
    var zip = get("postal_code");
    if (zip) $("mqzip").value = zip;
    if (city) $("mqcity").value = city;
    var msg = $("mqareaMsg");
    msg.style.display = "block";
    var outOfState  = state  && state !== GOOGLE.state;
    var outOfCounty = county && county.toLowerCase().indexOf(GOOGLE.county) < 0;
    if (outOfState || outOfCounty){
      S.outOfArea = true;
      msg.innerHTML = "That address is outside Sheboygan County — we can't get a truck out there. " +
                      "Call us at (920) 943-6422 if you think that's wrong.";
      return;
    }
    S.outOfArea = false;
    msg.innerHTML = "✓ " + esc(city || "That address") + " is in our delivery area.";
    hideErr("mqe2");
  }

  /* ---------------- lead delivery ---------------- */
  /* Shopify's captcha cancels any submit on a contact form and runs a challenge
     first. On a hidden form that challenge can't render, so it gives up and the
     submission is dropped silently. Shopify.captcha.protect runs it for us. */
  function ssPostForm(id, fields){
    var f = document.getElementById(id);
    if (!f) return false;
    Object.keys(fields).forEach(function(k){
      var el = f.querySelector('[name="' + k + '"]');
      if (el) el.value = fields[k];
    });
    try{
      if (window.Shopify && Shopify.captcha && Shopify.captcha.protect){
        Shopify.captcha.protect(f, function(){ try{ f.submit(); }catch(e){} });
        return true;
      }
    }catch(e){}
    var b = f.querySelector('[type="submit"]');
    if (b){ b.click(); return true; }
    if (f.requestSubmit){ f.requestSubmit(); return true; }
    f.submit();
    return true;
  }
  function ssPhoneE164(p){
    var d = String(p || "").replace(/\D/g, "");
    if (d.length === 10) return "+1" + d;
    if (d.length === 11 && d.charAt(0) === "1") return "+" + d;
    return null;
  }
  function ssKlaviyo(metricName, p){
    if (!KLAVIYO.publicApiKey) return;
    try{
      var prof = { email: p.email, first_name: p.first_name, last_name: p.last_name };
      var e164 = ssPhoneE164(p.phone_number);
      if (e164) prof.phone_number = e164;
      fetch("https://a.klaviyo.com/client/events/?company_id=" + encodeURIComponent(KLAVIYO.publicApiKey), {
        method:"POST",
        headers:{ "Content-Type":"application/json", "revision":"2024-10-15" },
        body: JSON.stringify({ data:{ type:"event", attributes:{
          metric:{ data:{ type:"metric", attributes:{ name: metricName } } },
          properties: p,
          profile:{ data:{ type:"profile", attributes: prof } }
        } } })
      })["catch"](function(){});
    }catch(e){}
  }
  function pad(label){ return (label + " ").padEnd ? (label + " ").padEnd(26, ".") : label + " ......"; }
  function leadSummary(p, q){
    var L = [];
    L.push("BULK MATERIALS ORDER — " + p.reference);
    L.push("");
    L.push("Name:      " + (p.first_name + " " + p.last_name).trim());
    L.push("Email:     " + p.email);
    L.push("Phone:     " + p.phone_number);
    L.push("Deliver:   " + p.address + ", " + p.city + " " + p.zip);
    L.push("");
    L.push("Material:  " + p.material_name);
    L.push("Quantity:  " + p.units + " " + p.unit);
    if (p.area_sqft) L.push("Area:      " + p.area_sqft + " sq ft at " + p.depth_in + " in deep");
    L.push("Service:   " + (p.install ? "Delivered AND spread" : "Delivery only"));
    if (p.bed_prep) L.push("           + bed prep");
    if (p.removal)  L.push("           + old mulch removed");
    L.push("");
    L.push("ESTIMATE");
    L.push("  " + pad("Material") + " " + money(q.material));
    L.push("  " + pad("Delivery") + " " + money(q.delivery));
    if (q.install) L.push("  " + pad("Spreading") + " " + money(q.install));
    if (q.prep)    L.push("  " + pad("Bed prep") + " " + money(q.prep));
    if (q.removal) L.push("  " + pad("Old mulch removal") + " " + money(q.removal));
    L.push("  " + pad("TOTAL") + " " + money(q.total));
    if (q.belowMin) L.push("");
    if (q.belowMin) L.push("NOTE: under the " + RATES.minUnits + "-unit minimum — bagged may be cheaper for them.");
    if (q.twoTrips) L.push("NOTE: over one load — priced as two trips.");
    if (p.notes){ L.push(""); L.push("Notes: " + p.notes); }
    L.push("");
    L.push("Marketing opt-in: " + (p.optin ? "yes" : "no"));
    L.push("Submitted from the bulk materials page.");
    return L.join("\n");
  }
  function sendLead(p, q){
    if (!/^https?:$/.test(location.protocol)){
      console.log("(preview mode — lead not sent)\n" + leadSummary(p, q));
      return;
    }
    try{
      if (p.optin){
        ssPostForm("ssCustomerForm", {
          "contact[first_name]": p.first_name,
          "contact[last_name]":  p.last_name,
          "contact[email]":      p.email,
          "contact[tags]":       "Materials Lead"
        });
      }
      ssPostForm("ssLeadForm", {
        "contact[name]":  (p.first_name + " " + p.last_name).trim(),
        "contact[email]": p.email,
        "contact[phone]": p.phone_number,
        "contact[body]":  leadSummary(p, q)
      });
    }catch(e){}
  }

  /* ---------------- events ---------------- */
  document.addEventListener("click", function(ev){
    var t = ev.target;
    if (!t || !t.closest) return;

    var as = t.closest("#mqaddrSuggest .as-item");
    if (as){ acChoose(parseInt(as.dataset.i,10)); return; }
    if (!t.closest("#mqaddrField")) acClose();

    var lot = t.closest("#mqmats .lot");
    if (lot){
      S.material = lot.dataset.mat;
      /* Follow the new material's own reference depth until the customer has
         made a depth choice of their own - see S.depthTouched. */
      if (!S.depthTouched) S.depth = mat().refDepth;
      buildMaterials(); buildDepths(); render(); return;
    }

    var dch = t.closest("#mqdepths .dchip");
    if (dch){
      S.depth = parseFloat(dch.dataset.depth);
      S.depthTouched = true;
      buildDepths(); hideErr("mqe1"); render(); return;
    }

    if (t.id === "mqsegArea" || t.id === "mqsegUnits"){
      S.mode = t.dataset.mode;
      $("mqsegArea").classList.toggle("on", S.mode === "area");
      $("mqsegUnits").classList.toggle("on", S.mode === "units");
      $("mqareabox").style.display = S.mode === "area" ? "block" : "none";
      $("mqunitbox").style.display = S.mode === "units" ? "block" : "none";
      /* bed prep is priced per sq ft. If they switch to entering yards/tons
         directly we no longer know the area, so drop it rather than charge
         for a stale number they can no longer see. */
      if (S.mode !== "area") S.bedPrep = false;
      render(); return;
    }

    var svc = t.closest(".svc[data-svc]");
    if (svc){
      var k = svc.dataset.svc;
      if (k === "install"){ S.install = !S.install; if (!S.install){ S.bedPrep = false; S.removal = false; } }
      if (k === "prep")    S.bedPrep = !S.bedPrep;
      if (k === "removal") S.removal = !S.removal;
      render(); return;
    }

    var go = t.closest("[data-go]");
    if (go){ show(parseInt(go.dataset.go,10)); return; }

    var st = t.closest("#mqsteps .st");
    if (st){ show(parseInt(st.dataset.s,10)); return; }

    if (t.id === "mqmBtn"){ show(Math.min(2, S.step+1)); return; }
  });

  function num(v){ var n = parseFloat(v); return (n && n > 0) ? n : null; }

  ["mqlen","mqwid"].forEach(function(id){
    $(id).addEventListener("input", function(){
      var l = num($("mqlen").value), w = num($("mqwid").value);
      S.sqft = (l && w) ? l * w : null;
      $("mqareaRead").textContent = S.sqft ? (Math.round(S.sqft).toLocaleString("en-US") + " sq ft") : "";
      hideErr("mqe1"); render();
    });
  });
  $("mqsqft").addEventListener("input", function(){
    S.sqft = num(this.value);
    $("mqareaRead").textContent = S.sqft ? (Math.round(S.sqft).toLocaleString("en-US") + " sq ft") : "";
    hideErr("mqe1"); render();
  });
  $("mqunits").addEventListener("input", function(){ S.units = num(this.value); hideErr("mqe1"); render(); });

  $("mqaddr").addEventListener("input", function(){
    S.outOfArea = false;
    var q = this.value.trim();
    clearTimeout(AC.timer);
    AC.timer = setTimeout(function(){ acFetch(q); }, 180);
  });
  ["mqfname","mqlname","mqemail","mqphone","mqaddr","mqcity","mqzip"].forEach(function(id){
    var el = $(id); if (!el) return;
    ["input","change"].forEach(function(evt){
      el.addEventListener(evt, function(){ this.classList.remove("bad"); hideErr("mqe2"); });
    });
  });

  /* ---------------- submit ---------------- */
  $("mqsubmit").addEventListener("click", function(){
    if (!validate(2)) return;
    var q = quote(), m = mat();
    var ref = "BM-" + String(Math.floor(Math.random()*9000)+1000);
    var payload = {
      first_name: $("mqfname").value.trim(),
      last_name:  $("mqlname").value.trim(),
      email:      $("mqemail").value.trim(),
      phone_number: $("mqphone").value.trim(),
      address:    $("mqaddr").value.trim(),
      city:       $("mqcity").value.trim(),
      zip:        $("mqzip").value.trim(),
      notes:      $("mqnotes").value.trim(),
      optin:      $("mqoptin").checked,
      material_key: m.k,
      material_name: m.nm,
      unit:       m.unit === "ton" ? "tons" : "yards",
      units:      q.units,
      area_sqft:  S.sqft || null,
      depth_in:   q.depth,
      install:    S.install,
      bed_prep:   S.bedPrep,
      removal:    S.removal,
      quoted_material: q.material,
      quoted_delivery: q.delivery,
      quoted_install:  q.install,
      quoted_prep:     q.prep,
      quoted_removal:  q.removal,
      quoted_total:    q.total,
      below_minimum:   q.belowMin,
      reference:  ref,
      source:     "bulk-materials-quote"
    };

    sendLead(payload, q);
    ssKlaviyo("Materials Order Requested", payload);

    if (window.dataLayer) window.dataLayer.push({
      event:"materials_quote_request", value:payload.quoted_total, reference:ref
    });

    $("mqdoneName").textContent = payload.first_name || "friend";
    $("mqdoneRef").textContent = "Reference " + ref;
    $("mqdoneRecap").innerHTML =
      '<div class="item"><span>' + esc(payload.material_name) + '</span><span class="amt">' + q.units + ' ' + esc(payload.unit) + '</span></div>' +
      (payload.area_sqft
        ? '<div class="item"><span>Covering</span><span class="amt">' + Math.round(payload.area_sqft).toLocaleString("en-US") + ' sq ft at ' + depthLabel(payload.depth_in) + '</span></div>'
        : '') +
      '<div class="item"><span>Delivering to</span><span class="amt">' + esc(payload.address) + '</span></div>' +
      '<div class="item"><span><b>Estimate</b></span><span class="amt">' + money(q.total) + '</span></div>';

    ["mp1","mp2"].forEach(function(id){ $(id).style.display = "none"; });
    $("mpDone").style.display = "block";
    var sts = $("mqsteps").children;
    for (var i=0;i<sts.length;i++){ sts[i].classList.add("done"); sts[i].classList.remove("active"); }
    $("mqfill").style.width = "100%";
    $("mqmbar").style.display = "none";
    celebrate();
    var el = $("mqtool");
    if (el) window.scrollTo({ top: el.offsetTop - 20, behavior:"smooth" });
  });

  function celebrate(){
    try{
      if (window.matchMedia && matchMedia("(prefers-reduced-motion:reduce)").matches) return;
      var box = $("mqconfetti");
      if (!box){
        box = document.createElement("div");
        box.id = "mqconfetti"; box.setAttribute("aria-hidden","true");
        box.style.cssText = "position:fixed;inset:0;pointer-events:none;z-index:5;overflow:hidden";
        document.body.appendChild(box);
      }
      var colors = ["#235029","#4c8a54","#7bbd82","#E0A500","#183a1e"];
      for (var i=0;i<70;i++){
        (function(i){
          var c = document.createElement("i");
          c.style.cssText = "position:absolute;top:-12px;width:9px;height:14px;opacity:.9;" +
            "animation:mqfall linear forwards;left:" + (Math.random()*100) + "vw;" +
            "background:" + colors[i % colors.length] + ";" +
            "animation-duration:" + (2.4 + Math.random()*1.8) + "s;" +
            "animation-delay:" + (Math.random()*0.5) + "s;" +
            "transform:rotate(" + (Math.random()*360) + "deg)";
          box.appendChild(c);
          setTimeout(function(){ if (c.parentNode) c.parentNode.removeChild(c); }, 4600);
        })(i);
      }
      if (!document.getElementById("mqfall-kf")){
        var st = document.createElement("style");
        st.id = "mqfall-kf";
        st.textContent = "@keyframes mqfall{to{transform:translateY(105vh) rotate(680deg);opacity:.9}}";
        document.head.appendChild(st);
      }
    }catch(e){}
  }

  buildMaterials();
  buildDepths();
  render();
  $("mqfill").style.width = "50%";
  loadMaps();
})();